import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as d from "../../reducers/domainReducer";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "../mychart/MyChartContainer";
import { MyChartHeading } from "../ecosystem/mybswh";

/**
 * Container component for the Admini Info page.
 * 
 */
class AdminInfo extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.AdminInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { serverData, primaryUser, currentUser } = this.props;
        const { proxyName } = Tools.getProxyName(primaryUser, currentUser);
        const heading = (
            <MyChartHeading heading="Administrative Information" proxyName={proxyName} />
        );
        return <MyChartContainer
            mode="patinfo"
            title="Administrative Information"
            heading={heading}
            byroute="false"
            serverData={serverData}
        />;
    }

}


const mapStateToProps = (state) => {
    return {
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminInfo);